/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Role_SalesInputs */

const en_role_sales = /** @type {(inputs: Role_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales`)
};

const es_role_sales = /** @type {(inputs: Role_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ventas`)
};

/**
* | output |
* | --- |
* | "Sales" |
*
* @param {Role_SalesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const role_sales = /** @type {((inputs?: Role_SalesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Role_SalesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_role_sales(inputs)
	return es_role_sales(inputs)
});